import React, { FC, useState } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { useCyberStore } from '@entities/tsp';
import { CountryWithIcon } from '@entities/country';
import { ChoiseChip } from '@shared/ui/molecules';
import { ICON_TCP } from '@shared/config';
interface CountryPickerProps {
  countries: CountryWithIcon[];
}
const CountryPicker: FC<CountryPickerProps> = ({
  countries
}) => {
  const [showMoreCountries, setShowMoreCountries] = useState<boolean>(false);
  const {
    activeCountry,
    setActiveCountry
  } = useCyberStore();
  const handleCountryClick = (country: CountryWithIcon) => () => {
    setActiveCountry(country.country);
  };
  const handleShowMoreCoutnriesClick = () => {
    setShowMoreCountries(prev => !prev);
  };
  return <CountryPickerWrapper>
      {countries.slice(0, showMoreCountries ? -1 : 4).map(country => <ChoiseChip key={country.country} size={{
      desktop: 'l',
      mobile: 'm'
    }} variant={activeCountry === country.country ? 'selected' : 'default'} icon={country.icon && <Image src={`${ICON_TCP}${country.icon}`} alt={country.country} height={24} width={24} />} onClick={handleCountryClick(country)}>
          {country.country}
        </ChoiseChip>)}
      {countries.length > 4 && <ChoiseChip size={{
      desktop: 'l',
      mobile: 'm'
    }} onClick={handleShowMoreCoutnriesClick}>
          {showMoreCountries ? 'Скрыть' : 'Другие страны'}
        </ChoiseChip>}
    </CountryPickerWrapper>;
};
export default CountryPicker;
const CountryPickerWrapper = /*#__PURE__*/styled('div')({
  name: "CountryPickerWrapper",
  class: "catjrzg",
  propsAsIs: false
});

require("./CountryPicker.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CountryPicker.tsx");